import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/emailUnread.svg';

import styles from './EmailUnreadIcon.styles';

type EmailUnreadIconProps = {
  className?: string;
};

const useStyles = makeStyles(styles, { name: 'EmailUnreadIcon' });

export default function EmailUnreadIcon({ className }: EmailUnreadIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.icon, className)}>
      <Icon />
    </span>
  );
}
